module.exports = __webpack_public_path__ + "img/btn_lixiang@2x.f38c3ad1.png";